'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Cpu } from 'lucide-react';
import {
  NestedSheet,
  NestedSheetContent,
  NestedSheetHeader,
  NestedSheetTitle,
  NestedSheetBody,
} from '@/shared/ui';
import {
  ModelContent,
  getModelSubtitle,
} from '../settings-content/ModelContent';
import type { RenderModelFamily } from '@/types/render';
import { SettingsSectionRow } from './SettingsSection';

interface ModelSectionProps {
  selectedModelFamily: RenderModelFamily;
  onModelFamilyChange: (family: RenderModelFamily) => void;
  hasChanges?: boolean;
}

export function ModelSection({
  selectedModelFamily,
  onModelFamilyChange,
  hasChanges = false,
}: ModelSectionProps) {
  const t = useTranslations('render.settings.model');
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  const subtitle = getModelSubtitle(selectedModelFamily, t);

  return (
    <>
      <SettingsSectionRow
        icon={Cpu}
        title={t('title')}
        subtitle={subtitle}
        hasChanges={hasChanges}
        onClick={() => setIsSheetOpen(true)}
      />

      <NestedSheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
        <NestedSheetContent>
          <NestedSheetHeader>
            <NestedSheetTitle>{t('title')}</NestedSheetTitle>
          </NestedSheetHeader>

          <NestedSheetBody className="px-4">
            <ModelContent
              selectedModelFamily={selectedModelFamily}
              onModelFamilyChange={onModelFamilyChange}
              variant="compact"
              closeOnSelect={() => setIsSheetOpen(false)}
            />
          </NestedSheetBody>
        </NestedSheetContent>
      </NestedSheet>
    </>
  );
}
